import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=33ffbea4&scoped=true&"
import script from "./contract.vue?vue&type=script&lang=js&"
export * from "./contract.vue?vue&type=script&lang=js&"
import style0 from "./contract.vue?vue&type=style&index=0&id=33ffbea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ffbea4",
  null
  
)

export default component.exports